import styled from 'styled-components';

export const PlayerHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const PlayerName = styled.h5`
    margin: 0;
    font-weight: 600;
    font-size: 1rem;
`;

export const PlayerPosition = styled.span`
    font-size: 0.85rem;
    color: #6c757d;
`;

export const BodyHeader = styled.div`
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
    align-items: center;
    justify-content: space-between;
`;

export const StatHighlight = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.85rem;
    margin-bottom: 0.25rem;

    span {
        color: ${({ theme }) => theme.colors.textSecondary};
    }

    strong {
        color: ${({ theme }) => theme.colors.primary};
        font-weight: bold;
    }
`;
